/* unplugin-vue-components disabled */import script from "./VideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=54cd4a7c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54cd4a7c"]])

export default __exports__